module.exports = __webpack_public_path__ + "67d1f983e074ac3187642f7ac320b3ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-4.png
// module id = 1656
// module chunks = 0